import { Button, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IBannerVacationProps {
  url: string;
  onClick: () => void;
}

export function BannerVacation({ url, onClick }: IBannerVacationProps) {
  return (
    <div className={styles['container']} data-testid="MobileAppBanner">
      <a href={url} target="_blank" rel="noreferrer" onClick={onClick} className={styles['wrapper']}>
        <div className={styles['title']}>
          <UIHeading2 color="text-on-bright-default">
            Проживите отпуск
            <br />
            по-новому
          </UIHeading2>
        </div>
        <Button size="M" theme="fill_white_primary">
          Подробнее
        </Button>
      </a>
    </div>
  );
}
